<div class="ui vertical pointing menu scroll">
  <a
    class="item"
    *ngFor="let chatbot of chatBotList; let i = index"
    (click)="selectChatBot(chatbot)"
    [class.active]="chatbot?.userId === selectedChabotUserId"
  >
    <img
      class="ui spaced avatar image"
      src="{{ chatbot?.photoURL }}"
      alt="{{ chatbot?.displayName }}"
    />
    <span>{{ chatbot?.displayName }}</span>
  </a>
</div>
